import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { sizing } from '@dora/components';

export function usePlatformMediaQuery(theme: Theme) {
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    const tablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
    return mobile
        ? sizing.Platform.MOBILE
        : tablet
        ? sizing.Platform.TABLET
        : sizing.Platform.DESKTOP;
}

export function usePortraitMediaQuery() {
    return useMediaQuery('(orientation: portrait)');
}
